'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _windowSize = require('../../redux/modules/windowSize');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWindowSizeListener = require('react-window-size-listener');

var _reactWindowSizeListener2 = _interopRequireDefault(_reactWindowSizeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowSizeContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var windowSize = (0, _windowSize.getWindowSize)(state);
    return {
        windowHeight: windowSize.height,
        windowWidth: windowSize.width
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        setWindowSize: _windowSize.setWindowSize
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(WindowSizeContainer, _Component);

    function WindowSizeContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WindowSizeContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WindowSizeContainer.__proto__ || (0, _getPrototypeOf2.default)(WindowSizeContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onResize = function (windowSize) {
            if (_this.props.windowHeight !== windowSize.windowHeight || _this.props.windowWidth !== windowSize.windowWidth) {
                _this.props.setWindowSize({
                    height: windowSize.windowHeight,
                    width: windowSize.windowWidth
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(WindowSizeContainer, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_reactWindowSizeListener2.default, {
                onResize: this.onResize
            });
        }
    }]);
    return WindowSizeContainer;
}(_react.Component)) || _class);
exports.default = WindowSizeContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/WindowSizeContainer/WindowSizeContainer.js
// module id = PosD
// module chunks = 57